import microuniversoApi from "app/api/microuniversoApi";
const $ = require('jquery')

export async function obterDadosLicenciamento() : Promise<string> {
    const porta = await microuniversoApi.Licenciamento.obterPorta()

    if (porta == null) {
        return null
    }

    return await microuniversoApi.Licenciamento.obterLicenciamento(porta)
}